/** Wiki: https://wiki.easydevel.com/books/camper-eshop/page/vyking-3d-probador-virtual-de-zapatos */
import { useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { track3D } from 'utils/dataLayers';
import { useI18n } from 'context/i18n';
import { RotateSVG } from 'components/iconsSVG/rotate';

const Viewer = dynamic(() => import('./viewer').then((mod) => mod.Viewer3D), { ssr: false });

export function Mobile3D({ code = '', mobile = false }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const hasSentEvent = useRef(false);

  const onClick = () => {
    setOpen((prev) => !prev);
    if (!open && !hasSentEvent.current) {
      hasSentEvent.current = true;
      track3D(code);
    }
  };

  return (
    <div
      data-mobile={mobile}
      className="relative flex aspect-[2/3] h-full w-full items-center justify-center bg-[#f2f2f2] data-[mobile=true]:h-[var(--slider-height)]"
    >
      <Viewer code={code} />
      {!open ?
        <div className="absolute inset-0 flex items-end justify-center bg-transparent">
          <button
            onClick={onClick}
            className="mb-16 flex items-center gap-1 border border-[#d1d5db] bg-[var(--color-white)] px-3 py-1 text-[var(--color-black)] shadow"
          >
            {t('ficha.producto', 'tap.3d')}
            <RotateSVG />
          </button>
        </div>
      : <button
          onClick={onClick}
          disabled={!open}
          className="absolute bottom-16 mx-auto flex items-center gap-1 px-3 py-1 text-[var(--color-black)] disabled:hidden"
        >
          {t('ficha.producto', 'close.3d')}
          <svg height="24" width="24" viewBox="0 0 18 18" className="h-3.5 w-3.5">
            <g fill="none" stroke="currentColor" strokeWidth={2} fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <path d="m16.664783 17.163575-15.664783-15.663441"></path>
              <path d="m16.664783 1.5-15.664783 15.663441"></path>
            </g>
          </svg>
        </button>
      }
    </div>
  );
}
